export default __webpack_public_path__ + "worker.ticker.js";